var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.qrUrl != '')?_c('img',{attrs:{"src":_vm.qrUrl,"alt":_vm.code}}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.code)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }